var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Interceptors from './Interceptors/Interceptors';
import Options from './Utils/Options';
import Loader from './Loaders/Loader';
import Emitter from './Utils/Emitter';
import Logger from './Utils/Logger';
//import fetchIntercept from "fetch-intercept";
/**
 * @class
 * @description Core class for the p2p plugin. It includes the options, the websocket communication,
 * @exports CdnBalancer
 */
export default class CdnBalancer extends Emitter {
    /**
     * Constructs CdnBalancer.
     * @param {constructionOptions} constructionOptions JSON with the options to construct the balancer.
     */
    constructor(constructionOptions) {
        super();
        this.isEnabled = true;
        this.defaultChunkDownloadTimeout = 0;
        this.options = new Options(constructionOptions);
        this.loader = new Loader(this.options);
        this.interceptors = new Interceptors(this);
        var cdnBalancer = this;
        var responseHeader = XMLHttpRequest.prototype.getResponseHeader;
        XMLHttpRequest.prototype.getResponseHeader = function (name) {
            let rh = responseHeader.call(this, name);
            return rh;
        };
        var allResponseHeader = XMLHttpRequest.prototype.getAllResponseHeaders;
        XMLHttpRequest.prototype.getAllResponseHeaders = function () {
            let rh = allResponseHeader.call(this);
            return rh;
        };
        var abort = XMLHttpRequest.prototype.abort;
        XMLHttpRequest.prototype.abort = function () {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore-next-line
            let segment = this.segment;
            abort.call(this);
        };
        var overrideMimeType = XMLHttpRequest.prototype.overrideMimeType;
        XMLHttpRequest.prototype.overrideMimeType = function (name) {
            overrideMimeType.call(this, name);
        };
        var requestHeader = XMLHttpRequest.prototype.setRequestHeader;
        XMLHttpRequest.prototype.setRequestHeader = function (name, value, ...rest) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore-next-line
            let segment = this.segment;
            if (segment) {
                segment.headers[name] = value;
                segment.retryBecauseNewHeaders = (segment.retryBecauseNewHeaders == 0) ? 1 : segment.retryBecauseNewHeaders;
            }
            requestHeader.call(this, name, value, ...rest);
        };
        var send = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function (data, ...rest) {
            var _a, _b, _c, _d, _e;
            return __awaiter(this, void 0, void 0, function* () {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore-next-line
                let segment = this.segment;
                if (!cdnBalancer.isEnabled || !segment || segment.isManifest) {
                    try {
                        send.call(this, data, ...rest);
                    }
                    catch (e) { }
                    return;
                }
                if (segment.retryBecauseNewHeaders == 1) {
                    segment.retryBecauseNewHeaders = 2;
                    segment.updateP2PId();
                    cdnBalancer.openAndSend(this, segment);
                    return;
                }
                try {
                    let statistics = cdnBalancer.getLoader().getStats().cdns;
                    let totalCdnBytes = 0;
                    let totalP2PBytes = 0;
                    for (var i = 0; i < statistics.length; i++) {
                        if (statistics[i].provider === 'P2P')
                            totalP2PBytes = totalP2PBytes + statistics[i].downloadedBytes;
                        else
                            totalCdnBytes = totalCdnBytes + statistics[i].downloadedBytes;
                    }
                    let p2pPct = ((totalP2PBytes) / (totalP2PBytes + totalCdnBytes)) * 100;
                    if (p2pPct > 0) {
                        Logger.log("P2P Traffic " + p2pPct + "%");
                    }
                }
                catch (e) { }
                let init = Date.now();
                let segmenIsAvailableFromAPeer = false;
                // Beacuse is possible a headers appeared in the set headers function
                segment.updateP2PId();
                let useLocalstorage = segment.useP2P;
                let storedSegment = cdnBalancer.loader.P2PLoader.getSegment(segment);
                if (!segment.forceHttp) {
                    if (!storedSegment || !storedSegment.data || storedSegment.data.byteLength < 2 || storedSegment.data.byteLength != storedSegment.realBodySize) {
                        if (segment.useP2P) {
                            segmenIsAvailableFromAPeer = cdnBalancer.getLoader().P2PLoader.request(segment);
                            Logger.log("Is segment available via P2P " + segment.origRes + " " + segmenIsAvailableFromAPeer);
                        }
                        // If p2p, tries to use load via p2p, if not, cdn
                        if (segmenIsAvailableFromAPeer) {
                            segment.cdnName = "P2P";
                            segment.cdnProvider = "P2P";
                            segment.useP2P = false; // just try once
                        }
                        if (!segmenIsAvailableFromAPeer || !segment || segment.cdnName != 'P2P') ///  !segment.rendition || !segment.rendition.targetDuration || segment.rendition.targetDuration<=0
                            useLocalstorage = false;
                    }
                    else {
                        useLocalstorage = true;
                    }
                }
                Logger.log(" Use P2P-> " + useLocalstorage + "  " + segment.cdnProvider + " " + segment.cdnName + "  " + segment.origRes + " " + segmenIsAvailableFromAPeer + " force http-> " + segment.forceHttp);
                Logger.log(" Use P2P2 -> " + useLocalstorage + " available from peer " + segmenIsAvailableFromAPeer + " segment " + segment + " rendition " + (segment === null || segment === void 0 ? void 0 : segment.rendition) + " target duration " + ((_a = segment === null || segment === void 0 ? void 0 : segment.rendition) === null || _a === void 0 ? void 0 : _a.targetDuration) + " target duration " + ((_b = segment === null || segment === void 0 ? void 0 : segment.rendition) === null || _b === void 0 ? void 0 : _b.targetDuration) + " cdn name " + (segment === null || segment === void 0 ? void 0 : segment.cdnName) + " or " + (segment === null || segment === void 0 ? void 0 : segment.origRes));
                if (!segmenIsAvailableFromAPeer || !useLocalstorage || segment.forceHttp) {
                    Logger.log("HTTP for -> " + segment.origRes);
                    cdnBalancer.getLoader().CDNLoader.getActiveRequests().set(segment.id, segment);
                    send.call(this, data, ...rest);
                    Logger.log("P2P3 no " + segmenIsAvailableFromAPeer + " for -> " + segment.origRes);
                }
                else {
                    Logger.log("P2P3 yes " + segmenIsAvailableFromAPeer + " for -> " + segment.origRes);
                    // just try p2p one
                    segment.forceHttp = true;
                    let data = storedSegment === null || storedSegment === void 0 ? void 0 : storedSegment.data;
                    let ready = storedSegment && (storedSegment === null || storedSegment === void 0 ? void 0 : storedSegment.data.byteLength) > 0 && ((data === null || data === void 0 ? void 0 : data.byteLength) === (storedSegment === null || storedSegment === void 0 ? void 0 : storedSegment.realBodySize));
                    let lastLenght = 0;
                    let timeout = (((_c = segment.rendition) === null || _c === void 0 ? void 0 : _c.targetDuration) || 0) * 1000 / 2;
                    if (timeout != 0 && cdnBalancer.defaultChunkDownloadTimeout < timeout)
                        cdnBalancer.defaultChunkDownloadTimeout = timeout;
                    if (timeout == 0)
                        timeout = cdnBalancer.defaultChunkDownloadTimeout;
                    if (timeout == 0)
                        timeout = 1000;
                    Logger.log("P2P Request TIMEOUT " + timeout + " " + segment.origRes);
                    while (!ready) {
                        yield new Promise(f => setTimeout(f, 50));
                        storedSegment = cdnBalancer.loader.P2PLoader.getSegment(segment);
                        data = storedSegment === null || storedSegment === void 0 ? void 0 : storedSegment.data;
                        lastLenght = (data === null || data === void 0 ? void 0 : data.byteLength) || 0;
                        ready = storedSegment && (storedSegment === null || storedSegment === void 0 ? void 0 : storedSegment.data.byteLength) > 0 && ((data === null || data === void 0 ? void 0 : data.byteLength) === (storedSegment === null || storedSegment === void 0 ? void 0 : storedSegment.realBodySize));
                        if (Date.now() - init > timeout) {
                            ready = true;
                            data = undefined;
                        }
                        else if ((Date.now() - init) > (timeout / 2) && (storedSegment == undefined || storedSegment.data == undefined || lastLenght < 20)) {
                            ready = true;
                            data = undefined;
                        }
                    }
                    // copying data to avoid concurrency prroblems with the storage delete proces.
                    if (data) {
                        data = data.slice(0, data.byteLength);
                    }
                    Logger.log("P2P READY FOR " + segment.origRes + " " + (data === null || data === void 0 ? void 0 : data.byteLength) + " " + (storedSegment === null || storedSegment === void 0 ? void 0 : storedSegment.realBodySize));
                    storedSegment = cdnBalancer.loader.P2PLoader.getSegment(segment);
                    if (data && ((_d = storedSegment === null || storedSegment === void 0 ? void 0 : storedSegment.data) === null || _d === void 0 ? void 0 : _d.byteLength) == (storedSegment === null || storedSegment === void 0 ? void 0 : storedSegment.realBodySize)) {
                        let readyStateChangeEvent = new CustomEvent('readystatechange');
                        let loadEndEvent = new CustomEvent('loadend');
                        let loadEvent = new CustomEvent('load');
                        let loadStartEvent = new CustomEvent('loadstart');
                        Object.defineProperty(this, 'response', { writable: true });
                        Object.defineProperty(this, 'status', { writable: true });
                        Object.defineProperty(this, 'statusText', { writable: true });
                        Object.defineProperty(this, 'readyState', { writable: true });
                        Object.defineProperty(this, 'byteLength', { writable: true });
                        Object.defineProperty(this, 'responseURL', { writable: true });
                        Object.defineProperty(this, 'responseType', { writable: true });
                        Object.defineProperty(this, 'responseType', { writable: true });
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore-next-line
                        this.byteLength = data.byteLength;
                        this.response = data;
                        this.status = 200;
                        this.statusText = 'OK';
                        this.readyState = XMLHttpRequest.DONE;
                        this.responseURL = segment.origRes;
                        this.responseType = 'arraybuffer';
                        try {
                            this.dispatchEvent(loadStartEvent);
                        }
                        catch (e) {
                            Logger.log("P2Pe Error on event re");
                        }
                        // need to support the logic of some players
                        yield new Promise(f => setTimeout(f, 5));
                        try {
                            this.dispatchEvent(readyStateChangeEvent);
                        }
                        catch (e) {
                            Logger.log("P2Pe Error on event re");
                        }
                        // need to support the logic of some players
                        yield new Promise(f => setTimeout(f, 5));
                        try {
                            this.dispatchEvent(loadEndEvent);
                        }
                        catch (e) {
                            Logger.log("P2Pe Error on event loade");
                        }
                        try {
                            this.dispatchEvent(loadEvent);
                        }
                        catch (e) {
                            Logger.log("P2Pe Error on event le");
                        }
                        Logger.log("P2P2 Download done -> " + (Date.now() - init) + "ms id:" + segment.p2pId + " size -> " + ((data.byteLength) / 1024) + "kb");
                    }
                    else {
                        // Be sure next time we will force http
                        Logger.log("P2P7  Update url on problems with p2p " + (Date.now() - init) + "ms timeout: " + timeout + " byte length-> " + ((_e = storedSegment === null || storedSegment === void 0 ? void 0 : storedSegment.data) === null || _e === void 0 ? void 0 : _e.byteLength) + " real size-> " + (storedSegment === null || storedSegment === void 0 ? void 0 : storedSegment.realBodySize));
                        cdnBalancer.getLoader().CDNLoader.getActiveRequests().set(segment.id, segment);
                        cdnBalancer.getLoader().CDNLoader.updateUrl(segment);
                        cdnBalancer.openAndSend(this, segment);
                    }
                }
            });
        };
        /****************** OPEN *********************/
        var open = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (method, url, ...rest) {
            if (!cdnBalancer.isEnabled) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore-next-line
                return open.call(this, method, url, ...rest);
            }
            let urlTest = url;
            let originalUrl = url;
            let byteLength = 0;
            let dontRewrite = false;
            let splitted = urlTest.split('?');
            urlTest = splitted[0];
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore-next-line
            if (this.segment == undefined) {
                Object.defineProperty(this, 'segment', { writable: true });
            }
            if (!url.includes("&rnpaw=") && !url.includes("?rnpaw="))
                if (method === "GET" && (urlTest.endsWith(".mp4") || urlTest.endsWith(".ts") || urlTest.endsWith(".m4s") || urlTest.endsWith(".mpd") || urlTest.endsWith(".m3u8"))) {
                    let params;
                    if (splitted.length > 1)
                        params = splitted[1];
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore-next-line
                    let segment = this.segment;
                    if (segment == undefined)
                        segment = cdnBalancer.simpleRequest(urlTest, params, {});
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore-next-line
                    if (this.segment == undefined) {
                        this.segment = segment;
                    }
                    this.addEventListener('load', function (e) {
                        cdnBalancer.getLoader().loadStartEM(this, segment, e);
                    });
                    this.addEventListener('loadstart', function (e) {
                        cdnBalancer.getLoader().loadStartEM(this, segment, e);
                    });
                    let oldReady = this.onreadystatechange;
                    this.addEventListener('readystatechange', function () {
                        let isOk = cdnBalancer.getLoader().readyStateChangeEM(this, segment);
                        if (isOk === false) {
                            Logger.log("Update url because http failure");
                            cdnBalancer.getLoader().CDNLoader.updateUrl(segment);
                            cdnBalancer.openAndSend(this, segment);
                        }
                    });
                    this.addEventListener('progress', function (e) {
                        cdnBalancer.getLoader().progressEM(this, segment, e);
                    });
                    this.addEventListener('loadend', function (e) {
                        cdnBalancer.getLoader().loadEndEM(this, segment, e);
                    });
                    this.addEventListener('error', function (e) {
                    });
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore-next-line
                    return open.call(this, method, segment.getNewUrl(), ...rest);
                }
            Logger.log("XHR-not-intercepted -> " + url);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore-next-line
            return open.call(this, method, url, ...rest);
        };
    }
    resolv() {
    }
    openAndSend(request, segment) {
        var _a;
        try {
            request.open("GET", segment.getNewUrl());
            if ((_a = segment.headers) === null || _a === void 0 ? void 0 : _a.Range) {
                request.setRequestHeader("Range", segment.headers.Range);
            }
            request.send();
        }
        catch (error) {
        }
    }
    /**
     * Redirects adapter's requests to loader.
     * If loader is not ready yet it retries again after 200ms.
     * @param {URL} url URL object for the request.
     * @param {callback} callback Callback method to call back when loaded.
     * @param {Object} headers Optional headers of the request.
     * @param {number} retries Number of retries before giving up to load a segment if it fails, optional.
     * @param {boolean} forceArrayBuffer set as true if is expected to get the manifest response in ArrayBuffer format.
     * @public
     */
    request(url, download, callbacks, headers, retries, forceArrayBuffer, stats) {
        this.loader.processSegment(url, true, callbacks, headers, retries, forceArrayBuffer, stats);
    }
    /**
     * Sets the manifest URL of the played content to the options object.
     * For url changes the loader is restarted.
     * @param {string} url Manifest url of the content being played.
     * @public
     */
    setManifestResource(url) {
        if (url && this.options.resource !== url) {
            this.options.resource = url;
            this.loader = new Loader(this.options);
            this.loader.loadCDNBalancerData();
        }
    }
    getLoader() {
        return this.loader;
    }
    addInterceptor(name, player) {
        this.interceptors.loadInterceptor(name, player);
    }
    simpleRequest(urlString, params, headers) {
        let url = new URL(urlString);
        if ((this.options.resource == undefined || this.options.resource === '')) {
            this.setManifestResource(url.toString());
        }
        let segment = this.loader.processSegment(url, false, [], headers);
        let override = (this.options.overrideManifest && segment.isManifest);
        segment.params = params;
        const header = (headers === null || headers === void 0 ? void 0 : headers.Range) || '';
        this.loader.segmentsMap.set(segment.getNewUrl() + header, url.toString());
        return segment;
    }
    enable() {
        this.isEnabled = true;
        this.loader.enable();
        this.loader.P2PLoader.isEnabled = true;
    }
    disable() {
        this.isEnabled = false;
        this.loader.disable();
        this.loader.P2PLoader.isEnabled = false;
    }
    getIsEnabled() {
        return this.isEnabled;
    }
    reload(constructionOptions) {
        if (constructionOptions != undefined)
            this.options = new Options(constructionOptions);
        this.loader.P2PLoader.destroy;
        this.loader = new Loader(this.options);
        this.isEnabled = true;
    }
}
